<template>
  <div class="container-fluid mb-5">
    <div class="row">
      <h2 class="text-center mx-auto pt-5 heading-lg">{{ data[0].heading }}</h2>

      <div class="col-sm-12 px-0">
        <div class="search-results-container" :class="`-mode-${$root.mode}`">
          <div class="container">
            <div class="nav-bar text-center row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <a
                    v-for="item in data[0].tab_content"
                    class="nav-bar-item col"
                    :class="{ active: selectedTabType === getSlug(item.name) }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType(getSlug(item.name))"
                    >{{ item.name }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div
        v-if="selectedTabType === getSlug(item.name)"
        class="healthcare-professionals-tab-wrapper"
        v-for="item in data[0].tab_content"
      >
        <div
          v-for="(stepData, index) in item.items"
          class="row py-5 items"
          v-bind:class="{
            'items-border-bottom': index !== item.items.length - 1,
          }"
        >
          <div class="col-md-5">
            <h4 class="heading d-lg-block d-md-none d-block">
              {{ stepData.heading }}
            </h4>
            <figure class="embed-responsive embed-responsive-1by1 stage">
              <iframe
                class="embed-responsive-item"
                v-bind:src="`//players.brightcove.net/2750693505001/${stepData.video}_default/index.html?videoId=${stepData.image.description}`"
                frameborder="0"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
                allow="encrypted-media"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  left: 0px;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </figure>
          </div>
          <div class="col-md-7 mt-5 mt-md-0 mt-lg-5 pl-md-5 pl-4">
            <h4 class="heading d-lg-none d-md-block d-none">
              {{ stepData.heading }}
            </h4>
            <p v-html="stepData.steps" class="steps"></p>
          </div>
        </div>
        <p
          class="disclaimer-text"
          v-if="item.disclaimer !== ''"
          v-html="item.disclaimer"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
import UrlHelpers from "../../mixins/url-helpers";

let SECTION_RESULT_GROUP_TYPES = "";

export default {
  name: "product-support", // global_search_results
  props: ["data"],
  created() {
    bus.$emit("navigation:reversed", true);
    // bus.$emit("navigation:search-disabled", true);
  },
  mixins: [UrlHelpers],
  data() {
    const pathParts = location.pathname
      .split("/")
      .filter((p) => p)
      .slice(0, 2);

    SECTION_RESULT_GROUP_TYPES = this.data[0].tab_content.map((a) =>
      this.getSlug(a.name)
    );

    return {
      slider: null,
      loading: false,
      selectedTabType: SECTION_RESULT_GROUP_TYPES[0]
        ? SECTION_RESULT_GROUP_TYPES[0]
        : "before-you-buy",
      resultGroups: [],
    };
  },
  computed: {
    tabAwareResultGroup() {
      return this.getResultGroupByType(this.selectedTabType);
    },
  },
  methods: {
    shouldShowNoResultsForTabType(type) {
      if (SECTION_RESULT_GROUP_TYPES.includes(type)) {
        return !this.numResultsForTabType(type);
      }

      return true;
    },
    selectTabType(tab) {
      this.selectedTabType = tab;
    },
    getResultGroupByType(type) {
      const resultGroup = this.resultGroups.filter((rg) => rg.type === type);

      if (resultGroup.length) {
        return resultGroup[0];
      }

      return null;
    },
    getSlug(name) {
      return name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.search-results-container {
  margin-bottom: 3.375rem;
  background-color: $cc-resmed-hero-blue;

  .results-description {
    span {
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }
  }

  &.-mode-md,
  &.-mode-sm,
  &.-mode-xs {
    .nav-bar {
      // flex-direction: column;
      // align-items: flex-start;
      margin-bottom: 0;

      .nav-bar-item::after {
        background-color: transparent;
        margin-top: 0;
        // margin-top: 0.375rem;
      }

      .nav-bar-item:not(.active) {
        color: $cc-resmed-grey-30;
      }
    }
  }
}

.nav-bar {
  margin: 0 -0.625rem 2.8125rem -0.625rem;
  display: flex;
  justify-content: center;

  .nav-bar-item {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: #fff;
    position: relative;
    padding: 0.625rem 1.25rem;
    border-left: 1px solid #fff;
    font-size: 1.125rem;
    &:last-child {
      border-right: 1px solid #fff;
    }
    &.active {
      background-color: #424243;
      &::after {
        content: "";
        position: absolute;
        left: 45%;
        top: 100%;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #424243;
      }
    }
  }
}

.healthcare-professionals-tab-wrapper {
  margin-top: -3rem;
}

.items-border-bottom {
  border-bottom: 1px solid #ccc;
}
.heading {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 1.5rem;
}
.steps {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-weight: 400;
  strong {
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-weight: 500;
  }
}
</style>

<style lang="scss">
.healthcare-professionals-tab-wrapper {
  &.-mode-xs,
  &.-mode-sm,
  &.-mode-md {
    .component-e505c56b {
      padding-top: 0;
    }

    .headline-text {
      padding-top: 0 !important;
      padding-left: 3.5rem;
      padding-right: 3.5rem;
    }
  }
  .steps {
    li {
      padding-bottom: 10px;
    }
  }
}
</style>
